import Modal from "@/common/components/Modal"
import TextArea from "@/common/components/TextArea"
import { reasonSchema, ReasonValidationSchema } from "@/common/schemas/reason.schema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { FileUploader } from "../FileUploader";
import { useRef } from "react";
import { ErrorMessage } from "../ErrorMessage";

interface ReasonModalProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  subtitle?: string;
  disabled?: boolean;
  onSubmit: (data: ReasonValidationSchema) => void;
}

const ReasonModal = ({ isOpen, setIsOpen, subtitle, disabled, onSubmit }: ReasonModalProps) => {
  const uploadFiscalDocumentRef = useRef(null);

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    setValue,
    setError,
    formState: { errors },
  } = useForm<ReasonValidationSchema>({
    resolver: zodResolver(reasonSchema),
  });

  const file = watch('file');

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirm={handleSubmit((data) => {
        onSubmit(data);
        setIsOpen(false);
      })}
      triggerDisabled={disabled}
      title="Justificativa para edição"
      titleClass="text-2xl font-bold mb-2"
      footer="Confirmar justificativa e salvar alterações"
      subtitle={subtitle}
      body={
        <form className="flex flex-col gap-4">
          <TextArea
            label="Justificativa"
            className="text-white-800"
            placeholder="Escreva aqui sua justificativa"
            {...register('value')}
            errorMessage={errors.value?.message as string || undefined}
            markAsRequired
          />

          <div>
            <FileUploader
              ref={uploadFiscalDocumentRef}
              name="file"
              accept="application/pdf, image/png, image/jpg, image/jpeg"
              title="Anexe o documento"
              className="w-full bg-yellow-op-2 border-none text-white-400"
              fileName={file ? file.name : undefined}
              currentFileUrl={file ? URL.createObjectURL(file) : undefined}
              handleChange={(file) => {
                clearErrors('file')
                setValue('file', file)
              }}
              maxFileSizeInMb={10}
              setError={(message) => setError('file', { message })}
            />

            {errors.file?.message && (
              <ErrorMessage
                name="file"
                message={errors.file?.message}
              />
            )}
          </div>
        </form>
      }
    />
  );
}

export default ReasonModal
